import { formatDate } from "@cp/toolkit";
import type { InboxFullMessageFragment, InboxMessageFragment } from "@qw/graphql";
import type { ComponentProps, FC } from "react";

import { cn } from "../../utils";

export type MaybePartialInboxMessage = InboxMessageFragment | InboxFullMessageFragment;

export interface MessageHeaderProps extends ComponentProps<"header"> {
  message: MaybePartialInboxMessage;
}

export const MessageHeader: FC<MessageHeaderProps> = ({ message, className, ...props }) => {
  const { cc, id, date, from, priority, replyTo, to } = message;

  return (
    <header
      {...props}
      className={cn(
        "text-xs [&_dt]:font-medium [&_dt]:text-muted-foreground [&_dd+dt]:mt-2 md:[&_dd+dt]:mt-0 [&_dt+dd]:mt-0.5 md:[&_dt+dd]:mt-0 [&_dd]:wrap-break-word [&_dd]:min-w-0",
        className
      )}
    >
      <dl className="grid md:grid-cols-[3.5rem_1fr] min-w-0 gap-x-3 md:gap-y-3">
        <dt>From</dt>
        <dd>{from}</dd>

        <dt>Date</dt>
        <dd>{formatDate(new Date(date), "LLL d, yyyy, h:mm aa")}</dd>

        <dt>To</dt>
        <dd>{to.join(", ")}</dd>

        {cc.length > 0 && (
          <>
            <dt>CC</dt>
            <dd>{cc.join(", ")}</dd>
          </>
        )}
        {replyTo && (
          <>
            <dt>Reply To</dt>
            <dd>{replyTo}</dd>
          </>
        )}

        {priority && (
          <>
            <dt>Priority</dt>
            <dd>{priority}</dd>
          </>
        )}

        <dt>Id</dt>
        <dd>{id}</dd>
      </dl>
    </header>
  );
};
